import { Input } from '../../ui/input';
import { Label } from '../../ui/label';
import { Textarea } from '../../ui/textarea';

const Field = ({ label, children }) => (
  <div>
    <Label className="text-xs">{label}</Label>
    {children}
  </div>
);

export const LandingTab = ({ value, onChange }) => {
  const landing = value.landing || {};
  const contact = value.contact || {};
  const setL = (k, v) => onChange({ ...value, landing: { ...landing, [k]: v } });
  const setC = (k, v) => onChange({ ...value, contact: { ...contact, [k]: v } });

  return (
    <div className="space-y-6">
      <div className="space-y-3">
        <h3 className="text-sm font-semibold">Tanıtım Sayfası (giriş ekranından önce)</h3>
        <Field label="Büyük Başlık">
          <Input value={landing.hero_title || ''} onChange={e => setL('hero_title', e.target.value)} data-testid="landing-hero-title-input" />
        </Field>
        <Field label="Açıklama">
          <Textarea rows={3} value={landing.hero_subtitle || ''} onChange={e => setL('hero_subtitle', e.target.value)} data-testid="landing-hero-subtitle-input" />
        </Field>
      </div>
      <div className="space-y-3">
        <h3 className="text-sm font-semibold">İletişim Bilgileri</h3>
        <p className="text-xs text-slate-500">Boş bırakılan alanlar sayfada gösterilmez. WhatsApp numarası girilirse sağ altta WhatsApp butonu çıkar.</p>
        <div className="grid sm:grid-cols-2 gap-3">
          <Field label="Telefon"><Input value={contact.phone || ''} onChange={e => setC('phone', e.target.value)} placeholder="0 (5xx) xxx xx xx" data-testid="contact-phone-input" /></Field>
          <Field label="WhatsApp"><Input value={contact.whatsapp || ''} onChange={e => setC('whatsapp', e.target.value)} placeholder="05xx xxx xx xx" data-testid="contact-whatsapp-input" /></Field>
          <Field label="E-posta"><Input value={contact.email || ''} onChange={e => setC('email', e.target.value)} placeholder="info@akillicozum.com.tr" data-testid="contact-email-input" /></Field>
          <Field label="Adres"><Input value={contact.address || ''} onChange={e => setC('address', e.target.value)} data-testid="contact-address-input" /></Field>
        </div>
      </div>
    </div>
  );
};
